// extracted by mini-css-extract-plugin
export default {"container":"DataGrid_container__MXveI"};